import { setFilter } from "../tradeByClientsUXSlice";
import { setData } from "../tradeByClientsDataSlice";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../../core/store/reducers";
import React from "react";
import { TradeByClientsReportFilter } from "../types";
import { useCopiedState } from "../../../../../core/util/hooks";

export const useTradeByClientsReportFilter = () => {
  const storeFilter = useSelector<StoreType, TradeByClientsReportFilter>(
    (store) => store.ux.reports.exchbusiness.tradeByClients.filter
  );
  const [filter, editFilter] = useCopiedState<TradeByClientsReportFilter>(
    storeFilter
  );

  const dispatch = useDispatch();
  const dispatchSetFilter = React.useCallback(() => {
    dispatch(setFilter(filter!));
    dispatch(setData());
  }, [dispatch, filter]);

  return [filter, editFilter, dispatchSetFilter] as [
    typeof filter,
    typeof editFilter,
    typeof dispatchSetFilter
  ];
};
